import bus from '@/utils/bus.js';
import { PERSISTEDSTATE_KEY, STORAGE_KEY_KEEP_LOGON, STORAGE_KEY_KEEP_TOKEN } from '@/constants';
import store from '@/store';

const authorization = () => {
  return (((JSON.parse((window.sessionStorage || {}).getItem(PERSISTEDSTATE_KEY.AUTH)) || {}).common || {}).auth || {}).token;
};

const interceptors = (instance, auth) => {
  instance.interceptors.request.use(
    config => {
      if (auth) config.headers['Authorization'] = authorization();
      return config;
    },
    error => {
      Promise.reject(error);
      return error.response;
    },
  );

  instance.interceptors.response.use(
    response => {
      // BEGIN::Added.by.KWShin.2026.09.30.
      // access token이 만료되면 서버는 refresh token으로 새 access token을 만들어 응답헤더(Authorization)에 실어준다.
      // 이를 받아두지 않으면 이후 모든 요청이 만료된 토큰을 들고 가서 서버가 요청마다 토큰을 다시 발급하게 된다.
      const token = (response.headers || {}).authorization;
      if (token && token != authorization()) {
        store.commit('common/auth/authorize', { status: store.state.common.auth.status, token });
        // 로그온 유지 기능이 켜져 있으면 새로고침 시 복원할 토큰도 함께 바꿔준다.
        if (window.localStorage.getItem(STORAGE_KEY_KEEP_LOGON) === 'true') window.localStorage.setItem(STORAGE_KEY_KEEP_TOKEN, token);
      }
      // FINISH::Added.by.KWShin.2026.09.30.
      return response;
    },
    async error => {
      if (error.response) {
        //-----------------------------------------------------------------------------------------
        // BEGIN::Modified.by.KWShin.2024.02.02.
        // bus.$emit('response:error', error);
        //-----------------------------------------------------------------------------------------
        /*
         * 401 Unauthorized 에러가 발생했을 때 로그온 유지 기능이 켜져 있다면,
         * 이건 refresh token이 만료된 경우이므로,
         * 로그온 유지 기능이 더 이상 동작해서는 안되므로
         * localStorage의 access token을 없애고 store에서도 access token을 없애주고 로그인 화면으로 이동한다.
         * 이 절차를 거치지 않으면 인증/보안 절차 상 로그온 유지 기능/토큰 만료로 인한 재로그인 기능을
         * 구현할 방법이 묘연하다.
         */
        const status = error.response.data.status;
        if (status == 401) {
          const keepLogon = window.localStorage.getItem(STORAGE_KEY_KEEP_LOGON) === 'true' ? true : false;
          if (keepLogon) {
            window.localStorage.removeItem(STORAGE_KEY_KEEP_LOGON);
            window.localStorage.removeItem(STORAGE_KEY_KEEP_TOKEN);
            await store._mutations['common/auth/reset'][0]();
            const url = new URL(location.href);
            window.location = `${url.protocol}//${url.host}/login`;
          }
          bus.$emit('response:error', error);
        } else {
          bus.$emit('response:error', error);
        }
        // FINISH::Modified.by.KWShin.2024.02.02.
        //-----------------------------------------------------------------------------------------
      }
      Promise.reject(error);
      return error.response;
    },
  );
  return instance;
};

export default interceptors;
